module.exports = {
      id: "play-usage",
      viewBox: "0 0 18 21",
      url: "img/" + "sprite.svg#play-usage",
      toString: function () {
        return this.url;
      }
    }